import React, {useEffect, useRef, useState} from 'react';

import * as S from './FileUploader.styles';

const FileLoader = ({
  width,
  height,
  textOnly,
  bgColor,
  fileTypes,
  onFileSelect,
  getFileInfo,
  children,
  setImageSizeExceededError,
}) => {
  const [filePath, setFilePath] = useState('');

  const inputRef = useRef();

  const updateImageDisplay = e => {
    const bytes = e.target.files[0].size;
    const byte = 1000000;
    const maxData = 5 * byte;

    if (bytes >= maxData) {
      setImageSizeExceededError('File Size Exceeded');
      return false;
    }
    setImageSizeExceededError && setImageSizeExceededError('');
    if (e.target.files && e.target.files[0]) {
      var reader = new FileReader();
      const fileContent = e.target.files[0];
      getFileInfo && getFileInfo(e.target.files);

      reader.onload = function(e) {
        setFilePath(e.target.result);
        onFileSelect && onFileSelect(e.target.result, fileContent);
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };

  return (
    <S.FileInput width={width} height={height} textOnly={textOnly} bgColor={bgColor}>
      <S.Content className="makeFlex hrtlCenter">{children}</S.Content>
      <input ref={inputRef} type="file" accept={fileTypes} onChange={updateImageDisplay} />
    </S.FileInput>
  );
};

export default FileLoader;
